module.exports = __webpack_public_path__ + "img/trigger-CVS-icon.22eadf71.svg";